import Paragraph from '../Paragraph/Paragraph'
import classes from './ClickableText.module.scss'

export interface Props {
  onClick: () => void
  children: string
}

const ClickableText = ({
  onClick,
  children
}: Props) =>
  <div
    className={classes.ClickableText}
    onClick={onClick}
    role='presentation'
  >
    <Paragraph variant='word-break'>
      {children}
    </Paragraph>
  </div>

export default ClickableText
